import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const extModules = [
  StoreDevtoolsModule.instrument({
    name: 'Gogis DevTools',
    maxAge: 50,
    connectInZone: true,
  }),
];
